import React, { Component } from 'react';
import 'assets/css/style.scss';
import { BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import Header from 'components/Header';
import PaymentContainer from 'components/PaymentContainer';
import Footer from 'components/Footer';
import { callInitCall, callSetPayment, invalidateSession, getMerchantDataFromReq } from 'actions/payment';
import { RedirectToURL } from 'components/Common';
import GlobalLoaderModal from "components/FDModal/global-loader";
import GlobalErrorModal from "components/FDModal/global-error";
import UPIErrorModal from "components/FDModal/upi-error";
import LoaderAndCallSetPayment from "components/FDModal/loader-and-call-set-payment";
import { urlParam, updateTheme } from 'lib/fp-utility'
import ConnectApp from 'components/connect_app';


class Layout extends Component {
    constructor(props){
        super(props)
        window.history.pushState(null, null, document.URL);
        this.state = {
            initialState: '',
            fromBankRetry: false,
            canDisplayModal: 'false',
            apiLoaded: false,
            displayIciciLogo: true,
            //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
            merchantInstitutionId: ''
        }
    }

    componentDidMount() {

        if(urlParam('errorCode')){
            this.setState({fromBankRetry: true})
        }
        this.props.callInitCall().then((res)=>{
           const { response } = res.payload.data
            //FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page
            this.setState({merchantInstitutionId:response.mConfig.mrchInstitutionId})
            if(response && response.mConfig && response.mConfig.mTheme){
                if(response.mConfig.integrationType === "MERCHANT_STATIC_PAYMENT_INTEGRATION")
                this.setState({displayIciciLogo:false})

                updateTheme(response.mConfig.mTheme)
            }
        })


        // Restricting Browser Back Button by Adding EventListener
        const invalid = urlParam('invalid')
        if(invalid)
            this.setState({fromBrowserBackError: true})
            
        window.addEventListener('popstate', () => {
            const baseURL = window.location.protocol + '//' + window.location.host + window.location.pathname
            invalidateSession().then((data)=>{
                window.history.pushState(null, null, baseURL+'?invalid=true');
                this.setState({fromBrowserBackError: true})
            })
        });
    }

    componentWillReceiveProps(nextProps){
        if(this.props.lstMerchWallet !== nextProps.lstMerchWallet){
            this.checkFPS(nextProps.lstMerchWallet)
        }
    }

    checkFPS(list){
        let obj = list && list.length && list.find(o => o.walletName === 'FPS' || o.walletName === 'ALIPAY' || o.walletName === 'WECHAT' );
        if(typeof obj === 'object') {
            this.setState({displayIciciLogo:false})
        }
    }


    render() {
        const sessionToken = urlParam('sessionToken')
        const configId = urlParam('configId')
        const errorCode = urlParam('errorCode')
        const invalid = urlParam('invalid')
        // console.log("ERROR MESSAGE",this.props.errorCode)
        const appBasePath = window.location.pathname.replace(/\//g, '');
        if (sessionToken && configId) {
            return (
                <Router basename={`/${appBasePath}`} >
                    { invalid ? <GlobalErrorModal /> : <GlobalLoaderModal /> }
                    <ConnectApp errorCode={errorCode} sessionToken={sessionToken} configId={configId} />
                </ Router>
            )
        }

        if (this.props.apiLoaded === false)
            return <GlobalLoaderModal />

        if (this.props.integrationType === 'MERCHANT_PAYMENT_MODE_CARD_INTEGRATION')
            return <LoaderAndCallSetPayment txnKey={this.props.txnKey} txnIv={this.props.txnIv} selectedPayment={this.props.selectedPayment} />

        if (this.props.redirectUrl)
            return <RedirectToURL url={this.props.redirectUrl} name='redirectUrl' />
        
        if(this.props.errorCode)
        return <GlobalErrorModal errorCode={this.props.errorCode} />
        

        if (this.props.errorMessage || this.state.fromBrowserBackError)
            return <GlobalErrorModal errMsg={this.props.errorMessage} />
        
            
        
       

        return (
            <Router>
                <Header merchantLogo={this.props.merchantLogo} merchantName={this.props.merchantName} />
                <PaymentContainer />
               {/* commented below -FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page */}
               {/* <Footer selectedPayment={this.props.selectedPayment} iciciLogo={this.state.displayIciciLogo} /> */}

                {/* FT-25778[STORY-138422]Dynamic Scheme Logo Display on commerce connect hosted page */}
                <Footer institutionId={this.state.merchantInstitutionId} iciciLogo={this.state.displayIciciLogo} />

                {this.props.canDisplayLoader && <GlobalLoaderModal />}

                {/* From Bank site to Hosted Page Retry Popup */}
                {(this.state.fromBankRetry || this.state.fromBrowserBackError) && <GlobalErrorModal errMsg={this.props.displayErrorMessage} retryBtn={true} from='fromBankRetry' />}

                {/* API Response Retry Popup */}
                {!this.props.upiError && this.props.redirectToRetryPayPage && <GlobalErrorModal errMsg={this.props.displayErrorMessage} retryBtn={true} errorType={this.props.errorType} canDisplayClose={this.props.canDisplayClose} />}

                {this.props.upiError && this.props.redirectToRetryPayPage && <UPIErrorModal modalClassName="custom-otp-popup errorInvalid-popup" errMsg={this.props.displayErrorMessage} errorType={this.props.errorType} retryBtn={true} canDisplayClose={this.props.canDisplayClose} />}
            </Router>
        );
    }
}

const mapStateToProps = state => {
    if (state.fdData.redirectUrl) {
        return { redirectUrl: state.fdData.redirectUrl }
    }else if(state.fdData.errorCode === "FPDR4025" ){
        return { apiLoaded: true, errorCode: state.fdData.errorCode }
    } else if (state.fdData.errorMessage) {
        return { apiLoaded: true, errorMessage: state.fdData.errorMessage }
    } else if (state.fdData.redirectToRetryPayPage) {
        if(state.fdData.globalConfig){
        // const { SessionToken, ConfigId, txnKey, txnIv, selectedPayment, globalConfig: { mConfig: { mLogoUrl: merchantLogo, merchantName, integrationType } } } = state.fdData
        const { displayErrorMessage, redirectToRetryPayPage, upiError ,globalConfig: { mConfig: { mLogoUrl: merchantLogo, merchantName, integrationType } }  } = state.fdData
        // return { apiLoaded: true, redirectToRetryPayPage: false, merchantLogo, merchantName, integrationType, txnKey, txnIv, selectedPayment, SessionToken, ConfigId }
        return { apiLoaded: true, displayErrorMessage, redirectToRetryPayPage, upiError,merchantLogo, merchantName ,integrationType}
        
        }else{
            const { displayErrorMessage, redirectToRetryPayPage, upiError } = state.fdData
            return { apiLoaded: true, displayErrorMessage, redirectToRetryPayPage, upiError }
        }

    } else if (state.fdData && state.fdData.globalConfig) {
        const { SessionToken, ConfigId, txnKey, txnIv, selectedPayment, lstMerchWallet, globalConfig: { mConfig: { mLogoUrl: merchantLogo, merchantName, integrationType } } } = state.fdData
        return { apiLoaded: true, redirectToRetryPayPage: false, merchantLogo, merchantName, integrationType, txnKey, txnIv, selectedPayment, SessionToken, ConfigId, lstMerchWallet }
    } else {
        return { apiLoaded: false, redirectToRetryPayPage: false }
    }
}

export default connect(mapStateToProps, { callInitCall, callSetPayment, getMerchantDataFromReq })(Layout);